/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Publish_UpdateInputs */

const en_inbox_na_publish_update = /** @type {(inputs: Inbox_Na_Publish_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the live app`)
};

const id_inbox_na_publish_update = /** @type {(inputs: Inbox_Na_Publish_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbarui yang online`)
};

/**
* | output |
* | --- |
* | "Update the live app" |
*
* @param {Inbox_Na_Publish_UpdateInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_publish_update = /** @type {((inputs?: Inbox_Na_Publish_UpdateInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Publish_UpdateInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_publish_update(inputs)
	return en_inbox_na_publish_update(inputs)
});